import apis from '@apis/index';
import queryKeys from '@constants/query-keys';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { IMyInfo } from 'interfaces/my-info';

export const getPointTotal = () =>
  useQuery([...queryKeys.LOG.POINTS.TOTAL], apis.log.fetchTotalPoints);

export const fetchUserInfo = (options?: UseQueryOptions<IMyInfo, Error>) =>
  useQuery<IMyInfo, Error>(
    [...queryKeys.USER.INFO],
    apis.auth.fetchUserInfo,
    options,
  );
